export default function redirect(asset) {
    location.href = asset.eventId
}

